const ErrorMessage = ({ message }: { message?: string }) => {
  if (!message) return null;
  return (
    <>
      <span
        role="alert"
        aria-live="polite"
        className="d-inline-block mt-1 fs-5 text-danger"
      >
        {message}
      </span>
    </>
  );
};
export default ErrorMessage;
